import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const getGroupMembershipList = createAsyncSagaAction(actionTypes.GET_GROUP_MEMBERSHIP);
export const updateGroupmembershipList = createAsyncSagaAction(actionTypes.UPDATE_GROUP_MEMBERSHIP);
export const clearGroupMembershipData = () => ({type: actionTypes.CLEAR_GROUP_MEMBERSHIP_DATA});
